export default "__VITE_ASSET__B$7Lr3aE__"